export default {
  tags: {
    preferred: 'Bevorzugt',
  },
};
